import Repository from '@/app/repositories/repository'
import {RepositoryFactory} from '@/app/repositories/repository-factory.js'

const UserRepository = RepositoryFactory.get('user');

export default Object.assign(UserRepository, {
    requestCurrentUserInfo: function(){
        //TODO-WALT: NOT WORKING
        return Repository.post(`${this.resource}/getCurrentUserInfo`);
    },
    userInfo : {},
    setUserInfo : function(value){
        this.userInfo = value;
        //Persist in local storage
        localStorage.userInfo = JSON.stringify(value);
    },
    getCurrentUserInfo: function(){
        return localStorage.userInfo ? JSON.parse(localStorage.userInfo) : this.userInfo;
    },
    clear : function(){
        this.userInfo = {};

        //Remove localStorage
        delete localStorage.userInfo;
    }
});